import { Logger, RpcError, RpcErrorCode, RpcNode, } from "@ledgerhq/wallet-api-core";
import { AccountModule } from "./modules/Account";
import { BitcoinModule } from "./modules/Bitcoin";
import { CurrencyModule } from "./modules/Currency";
import { DeviceModule } from "./modules/Device";
import { ExchangeModule } from "./modules/Exchange";
import { MessageModule } from "./modules/Message";
import { StorageModule } from "./modules/Storage";
import { TransactionModule } from "./modules/Transaction";
import { WalletModule } from "./modules/Wallet";
export const defaultLogger = new Logger("Wallet-API-Client");
// temporary
const requestHandlers = {
    "event.account.updated": (_request) => {
        // eslint-disable-next-line no-console
        console.log("accounts updated !");
        return Promise.resolve();
    },
};
/**
 * WalletAPI Client which rely on WindowMessage communication
 */
export class WalletAPIClient extends RpcNode {
    /**
     * Instance of the Account module
     */
    account;
    /**
     * Instance of the Bitcoin module
     */
    bitcoin;
    /**
     * Instance of the Currency module
     */
    currency;
    /**
     * Instance of the Device module
     */
    device;
    /**
     * Instance of the Message module
     */
    message;
    /**
     * Instance of the Storage module
     */
    storage;
    /**
     * Instance of the Transaction module
     */
    transaction;
    /**
     * Instance of the Wallet module
     */
    wallet;
    /**
     * Instance of the Wallet module
     */
    exchange;
    /**
     * Instance of the Custom module
     */
    custom;
    logger;
    constructor(transport, logger = defaultLogger, getCustomModule) {
        super(transport, requestHandlers);
        this.logger = logger;
        this.account = new AccountModule(this);
        this.bitcoin = new BitcoinModule(this);
        this.currency = new CurrencyModule(this);
        this.device = new DeviceModule(this);
        this.message = new MessageModule(this);
        this.storage = new StorageModule(this);
        this.transaction = new TransactionModule(this);
        this.wallet = new WalletModule(this);
        this.exchange = new ExchangeModule(this);
        this.custom = (getCustomModule ? getCustomModule(this) : {});
    }
    onRequest(request) {
        this.logger.log(request.method);
        const handler = this.requestHandlers[request.method];
        if (!handler) {
            throw new RpcError({
                code: RpcErrorCode.METHOD_NOT_FOUND,
                message: "method not found",
            });
        }
        return handler(request);
    }
}
//# sourceMappingURL=WalletAPIClient.js.map